"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
    MessageType["TEXT"] = "TEXT";
    MessageType["STATUS"] = "STATUS";
    MessageType["IMAGE"] = "IMAGE";
    MessageType["AUDIO"] = "AUDIO";
    MessageType["VIDEO"] = "VIDEO";
    MessageType["DOCUMENT"] = "DOCUMENT";
    MessageType["NOTSET"] = "NOTSET";
    MessageType["LOCATION"] = "LOCATION";
    MessageType["CONTACT"] = "CONTACT";
    MessageType["TASK_CREATED"] = "TASK_CREATED";
    MessageType["TASK_CHANGED"] = "TASK_CHANGED";
    MessageType["TASK_COMPLETED"] = "TASK_COMPLETED";
    MessageType["TASK_ASSIGNEE_CHANGED"] = "TASK_ASSIGNEE_CHANGED";
    MessageType["TASK_COMMENT_ADDED"] = "TASK_COMMENT_ADDED";
    MessageType["TASK_DUE_DATE_CHANGED"] = "TASK_DUE_DATE_CHANGED";
    MessageType["TASK_ATTACHMENT_ADDED"] = "TASK_ATTACHMENT_ADDED";
    MessageType["TASK_TRACKING_ADDED"] = "TASK_TRACKING_ADDED";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
//# sourceMappingURL=MessageType.js.map